import React from "react";
// import ReactDOM from "react-dom";
// import { TokenAnnotator, TextAnnotator } from "react-text-annotate";
// import Tagger from "./tagger";
import { Upload } from "./upload";
class App extends React.Component {

  render() {
    return (
      <div style={{ padding: 24, fontFamily: "IBM Plex Sans" }}>
        <Upload></Upload>
      </div>
    );
  }
}


export default App;